import { z } from "zod";

export const createInitialVehicleRestitutionResponse = z.object({
  uuid: z.uuid(),
  picturesUploaded: z.array(z.uuid()),
});

export type CreateInitialVehicleRestitutionResponse = z.infer<
  typeof createInitialVehicleRestitutionResponse
>;
